import React from 'react';
import {
  formartDateTimeUTC,
  formatFederalTaxNumber,
  formatPhone
} from 'util/formatters';

const Display = ({
  className = '',
  value,
  loading,
  isPhone,
  isFederalTaxNumber,
  isDate,
  format
}) => {
  if (loading) {
    return <span className="skeleton-loader-gradient" />;
  }

  let formattedValue = value;
  let classNames = ['gx-text-wrap-nowrap'];

  if (className) {
    classNames = [className];
  }

  if (isPhone) {
    formattedValue = formatPhone(value);
  }

  if (isFederalTaxNumber) {
    formattedValue = formatFederalTaxNumber(value);
  }

  if (isDate) {
    formattedValue = formartDateTimeUTC(value, format);
  }

  return <span className={classNames.join(' ')}>{formattedValue}</span>;
};

export default Display;
